import { useEffect, useState } from "react";
import useInventory from "../../../services/Inventory/useInventory";
import useGlobalInventory from "../../../services/Inventory/useGlobalInventory";
import { X } from "lucide-react";
import { toast, ToastContainer } from "react-toastify";

const BarcodeModal = ({ open, onClose, item }) => {
  const { getItemDetails, addBarcodeToItem } = useInventory();
  const { addItemsToInventory } = useGlobalInventory();

  const [barcode, setBarcode] = useState("");
  const [loading, setLoading] = useState(false);
  const [itemDetails, setItemDetails] = useState(null);

  useEffect(() => {
    if (open && item?.id) {
      fetchDetails();
    }
  }, [open, item]);

  useEffect(() => {
    if (!open) {
      setBarcode("");
      setItemDetails(null);
    }
  }, [open]);

  const fetchDetails = async () => {
    setLoading(true);
    const res = await getItemDetails(item.id);

    if (res?.response) {
      const data = res.response;

      setItemDetails(data);
      setBarcode(data?.barcodeNumber || "");
    }

    setLoading(false);
  };

  const handleSubmit = async () => {
    if (!barcode) return toast.error("Enter barcode");

    setLoading(true);

    try {
      const res = await addBarcodeToItem({
        barCode: barcode,
        inventoryId: item.id,
      });

      if (res?.responseCode === "00") {
        toast.success("Barcode added successfully");

        onClose();
      } else {
        toast.error(res?.responseMessage || "Failed");
      }
    } catch (err) {
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitAndAdd = async () => {
    if (!barcode) return toast.error("Enter barcode");

    setLoading(true);

    try {
      const res1 = await addBarcodeToItem({
        barCode: barcode,
        inventoryId: item.id,
      });

      if (res1?.responseCode !== "00") {
        toast.error(res1?.responseMessage || "Barcode failed");
        return;
      }

      const res2 = await addItemsToInventory([item.id]);

      if (res2?.responseCode === "00") {
        toast.success("Added to inventory successfully");

        onClose();
      } else {
        toast.error(res2?.responseMessage || "Inventory failed");
      }
    } catch (err) {
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  if (!open) return null;

  return (
    <>
    <ToastContainer/>
    
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 montserrat-font-1">
      <div className="bg-white w-[400px] rounded-xl p-5 relative montserrat-font-1">
        {/* CLOSE */}
        <button onClick={onClose} className="absolute top-3 right-3">
          <X />
        </button>

        <h2 className="text-lg font-semibold text-center mb-3">
          Add Barcode to {item?.productName}
        </h2>

        <div className="flex justify-center mb-2">
          <img src={item?.productImage} className="h-20 object-contain" />
        </div>

        <p className="text-center text-xs text-gray-500 mb-3">
          {item?.category} → {item?.subCategory}
        </p>

        {barcode && (
          <div className="mb-2 text-sm text-gray-600 text-center">
            Assigned barcode :{" "}
            <span className="font-semibold text-green-600">{barcode}</span>
          </div>
        )}
        <input
          type="text"
          value={barcode}
          onChange={(e) => setBarcode(e.target.value)}
          placeholder="Enter barcode"
          className="w-full border rounded-lg p-2 mb-4 text-center"
        />

        <div className="flex gap-3">
          <button
            onClick={handleSubmit}
            disabled={loading}
            className="flex-1 bg-green-600 text-white py-2 rounded-lg disabled:opacity-50"
          >
            {loading ? "Processing..." : "Submit"}
          </button>

          <button
            onClick={handleSubmitAndAdd}
            disabled={loading}
            className="flex-1 bg-blue-600 text-white py-2 rounded-lg"
          >
            Submit & Add
          </button>
        </div>
      </div>
    </div>
    </>
  );
};

export default BarcodeModal;
